import { Api } from '../types/Api';

// 提问
const setLang: Api = {
    url: '/common/v1/set/language',
    method: 'post',
};
const getCurrentUser: Api = {
    url: '/user/v1/getCurrentUser',
    method: 'get',
};

const userLogout: Api = {
    url: '/user/v1/userLogout',
    method: 'delete',
};

export { setLang, getCurrentUser, userLogout };
